import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navbar"
export default class extends Controller {
  static outlets = [ "request" ]
  static targets = [ "container", "toggle" ]
  static values = {
    id: Number
  }

  toggle(event) {
    let target = event.currentTarget
    let container = this.hasContainerTarget ? this.containerTarget : this.element
    if((target.classList.contains("navbar-company-container") && 
       !container.classList.contains("collapsed")) ||
       event.target.closest(".home-options"))
       return
    container.classList.toggle("collapsed")
    if(this.hasToggleTarget)
      this.toggleTarget.setAttribute("aria-expanded", !container.classList.contains("collapsed"))

    this.requestOutlet.sendPostRequest({
      url: `/user_preferences/${this.idValue}`,
      params: {
        expanded_nav_bar: !container.classList.contains("collapsed")
      }
    })
  }

  expand(event) {
    let target = event.currentTarget
    let parent = event.target.closest(".home-options, .navbar-user-options")
    if((event.target.tagName === "INPUT" || event.target.tagName === "BUTTON") && (!parent || parent?.classList?.contains("home-options")))
      return
    if(parent){
      event.stopPropagation()
      parent.classList.toggle("expand")
    } else target.classList.toggle("expand")
    
  }
}
